@if (groups && groups.length) {
  @if (header) {
    <app-header
      icon="fas fa-filter"
      [styleClass]="headerStyleClass"
      [text]="header"></app-header>
  }
  <app-form-field-wrapper
    [floatingLabel]="floatingLabel"
    [label]="label"
    [name]="name"
    [styleClass]="styleClass"
    [colSize]="colSize">
    <p-dropdown
      [placeholder]="placeholder"
      [showClear]="!!selection"
      [options]="groups"
      [(ngModel)]="selection"
      [styleClass]="dropDownStyleClass"
      (onChange)="onSelectionChange($event.value)">
      <ng-template pTemplate="clearicon">
        <i
          class="flex fas fa-filter-circle-xmark"
          pTooltip="Alle Gruppen anzeigen"></i>
      </ng-template>

      <ng-template pTemplate="selectedItem" let-selectedOption>
        <div class="flex gap-2 align-items-center">
          <i class="fas fa-circle-nodes text-center"></i>
          <span>{{ selectedOption }}</span>
        </div>
      </ng-template>
      <ng-template let-item pTemplate="item">
        <div class="flex gap-2 align-items-center">
          <i class="fas fa-circle-nodes text-center"></i>
          <span>{{ item }}</span>
        </div>
      </ng-template>
    </p-dropdown>
  </app-form-field-wrapper>
}
